module.exports = __webpack_public_path__ + "images/bewuzt_smalla652dcdfeda7093086d885c8b2840521.png";